import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';

import MealLogContainer from './MealLogContainer';
import NewMealLogContainer from './NewMealLogContainer';
import MealSelectContainer from './MealSelectContainer';
import LogMealContainer from './LogMealContainer';
import NotFoundPage from '../../components/home/NotFoundPage';

const MealLogNavigator = ({ loginState, authToken, history }) => {
  if (loginState !== 'LOGGED_IN' || !authToken) {
    history.push('/');
    return false;
  }
  return (
    <Switch>
      <Route path="/logmeal" exact component={NewMealLogContainer} />
      <Route path="/logmeal/select" component={MealSelectContainer} />
      <Route path="/logmeal/log" component={LogMealContainer} />
      <Route path="*" component={NotFoundPage} />
    </Switch>
  );
};

const mapStateToProps = (state) => ({
  loginState: state.app.loginState,
  authToken: state.user.authToken,
});

export default connect(mapStateToProps)(MealLogNavigator);
